const getDefaultState = () => {
    return {
        saleproduct_state: 0,
        saleproduct_package: {},
        saleproduct_member: null,
        saleproduct_payment: {
            price: null,
            qty: null,
            session: null,
            duration: null,
            duration_unit: null,
            activate_date: null,
            discount: null,
            discount_unit: null,
            total: null,
            paidby: null,
            note: null,
            saleproduct_date: null
        },
        saleproduct_employee: null
    };
};

const state = getDefaultState();

const getters = {
    getSaleProductPackage: (state) => {
        return state.saleproduct_package;
    },
    getSaleProductState: (state) => {
        return state.saleproduct_state;
    },
    getSaleProductMember: (state) => {
        return state.saleproduct_member;
    },
    getSaleProductPayment: (state) => {
        return state.saleproduct_payment;
    },
    getSaleProductEmployee: (state) => {
        return state.saleproduct_employee;
    },
};

const mutations = {
    setSaleProductState(state, payload) {
        state.saleproduct_state = payload;
    },
    setSaleProductPackage(state, payload) {
        state.saleproduct_package = payload;
    },
    setSaleProductMember: (state, payload) => {
        state.saleproduct_member = payload;
    },
    setSaleProductEmployee: (state, payload) => {
        state.saleproduct_employee = payload;
    },
    setSaleProductPayment: (state, payload) => {
        state.saleproduct_payment = payload;
    },
    resetSaleProduct: (state) => {
        Object.assign(state, getDefaultState());
    },
};

const actions = {
    setSaleProductState({
        commit
    }, payload) {
        commit("setSaleProductState", payload);
    },
    setSaleProductPackage({
        commit
    }, payload) {
        commit("setSaleProductPackage", payload);
        //localStorage.setItem("saleproduct_package", JSON.stringify(payload));
    },
    setSaleProductMember({
        commit
    }, payload) {
        commit("setSaleProductMember", payload);
    },
    setSaleProductEmployee({
        commit
    }, payload) {
        commit("setSaleProductEmployee", payload);
    },
    setSaleProductPayment({
        commit
    }, payload) {
        commit("setSaleProductPayment", payload);
    },
    resetSaleProduct({
        commit
    }) {
        commit("resetSaleProduct");
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};